import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { Message, Modal, Input, Button, List, Icon,
    Checkbox } from 'semantic-ui-react'

import Select from "react-select";

import { useSelector, useDispatch, shallowEqual } from "react-redux";

// shadcn components
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button as ShadcnButton } from "../../components/ui/button";
import { Input as ShadcnInput } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";
import { Badge } from "../../components/ui/badge";
import { Alert, AlertDescription } from "../../components/ui/alert";
import { AlertCircle, Plus, Minus, Palette } from "lucide-react";

import { CATEGORY_COMPLIANCE_HEADERS, 
    PriorityList, CATEGORY_VISIBILITY, 
    CATEGORY_INPUT } from "data/AdminData"

import {
    SG_EDIT_SURVEY_STRUCTURE,
    SG_SURVEY_STRUCTURE_COMPLIANCE_SELECT
} from "constants/actions";



const NewCategory = (props) => {

    const { rowId,
        trigger,
        surveyStruc,
        setSurveyStruc,
        surveyStrucRow,
        setSurveyStrucRow,
        openNewCategory,
        setOpenNewCategory,
        organizationId,
        surveyStructureId,
        setUpdateJsonFile, 
        setLoading,
    } = props

    const dispatch = useDispatch();

    const [pristine, setPristine] = useState(true)
    const [listName, setListName] = useState('')
    // const [open, setOpen] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [color, setColor] = useState('#BCBCBC')
    const [formErrors, setFormErrors] = useState([]);
    const [prioritySelected, setPrioritySelected] = useState(false)
    const [visibilitySelected, setVisbilitySelected] = useState(false)
    const [inputSelected, setInputSelected] = useState(false)

    const [demographicValue, setDemographicValue] = useState(false)
    const [hiddenValue, setHiddenValue] = useState(false)
    const [allowSkipValue, setAllowSkipValue] = useState(false)
    const [requireSpecialAccessValue, setRequireSpecialAccessValue] = useState(false)
    const [removeFromAnalyticsValue, setRemoveFromAnalyticsValue] = useState(false)
    const [allowOpenEndedValue, setAllowOpenEndedValue] = useState(false)
    const [openEndedName, setOpenEndedName] = useState('')
    const [openEndedNameFr, setOpenEndedNameFr] = useState('')
    const [selectedOptions, setSelectedOptions] = useState(false)
    const [optionList, setOptionList] = useState([])
    const [selectedOptionList, setSelectedOptionList] = useState(false)

    // console.log(rowId)
    const { get_category_compliance } = useSelector(
        (state) => ({
            get_category_compliance: state.surveystructurecompliance.survey_struture_select,
        }),
        shallowEqual
    );

    useEffect(() => {
        setPrioritySelected(PriorityList.find(({ value }) => value === surveyStruc?.priority))
        setVisbilitySelected(CATEGORY_VISIBILITY.find(
            ({ value }) => value === surveyStruc?.visibility))
        setInputSelected(CATEGORY_INPUT.find(
            ({ value }) => value === surveyStruc?.input))
        setDemographicValue(surveyStruc?.demographic ? surveyStruc?.demographic : false)
        setHiddenValue(surveyStruc?.hidden ? surveyStruc?.hidden : false)
        setAllowSkipValue(surveyStruc?.allow_skip ? surveyStruc?.allow_skip : false)
        setRequireSpecialAccessValue(
            surveyStruc?.require_special_access ? surveyStruc?.require_special_access : false
        )
        setRemoveFromAnalyticsValue(
            surveyStruc?.remove_from_analytics ? surveyStruc?.remove_from_analytics : false
        )
        setAllowOpenEndedValue(surveyStruc?.allow_open_ended ? surveyStruc?.allow_open_ended : false)
        setOpenEndedName(surveyStruc?.open_ended_name || '')
        setOpenEndedNameFr(surveyStruc?.open_ended_name_fr || '')
    }, [surveyStruc]);

    useEffect(() => {
        const PriorityId = CATEGORY_COMPLIANCE_HEADERS.filter(cc => cc.small === prioritySelected?.value)?.[0]?.value
        dispatch({
            type: SG_SURVEY_STRUCTURE_COMPLIANCE_SELECT,
            payload: `priority=${PriorityId || ''}`
        });
    }, [dispatch, prioritySelected]);

    function ChangedPriority(e) {
        AddDetails("priority", e.value)
        setPrioritySelected(e)
        setSelectedOptions(false)
        setOptionList([])
        setSelectedOptionList(false)
    }

    function ChangedVisibility(e) {
        AddDetails("visibility", e.value)
        setVisbilitySelected(e)
    }
    function ChangedDemograhic() {
        
        setDemographicValue(!demographicValue)
        // setVisbilitySelected(e)
        AddDetails("demographic", !demographicValue)
    }

    function ChangedHidden() {
        
        setHiddenValue(!hiddenValue)
        // setVisbilitySelected(e)
        AddDetails("hidden", !hiddenValue)
    }
    function ChangedAllowSkip() {
        setAllowSkipValue(!allowSkipValue)
        AddDetails("allow_skip", !allowSkipValue)
    }

    function ChangedRequireSpecialAccess() {
        setRequireSpecialAccessValue(!requireSpecialAccessValue)
        AddDetails("require_special_access", !requireSpecialAccessValue)
    }

    function ChangedRemoveFromAnalytics() {
        setRemoveFromAnalyticsValue(!removeFromAnalyticsValue)
        AddDetails("remove_from_analytics", !removeFromAnalyticsValue)
    }

    function ChangedAllowOpenEnded() {
        setAllowOpenEndedValue(!allowOpenEndedValue)
        AddDetails("allow_open_ended", !allowOpenEndedValue)
    }
    // console.log(demographicValue)

    function ChangedInput(e) {
        AddDetails("input", e.value)
        setInputSelected(e)
    }

    function ChangedOption(e) {
        setSelectedOptions(e)
        setOptionList(e.categories)
    }

    function ChangedOptionList(e) {
        setSelectedOptionList(e)
    }
    
    // console.log("surveyStruc", surveyStruc)
    // console.log(surveyStruc?.demographic)
    // console.log(demographicValue)

    const onSubmit = () => {
        if (formErrors.length > 0) {
            setPristine(false)
            return
        }
        setPristine(true)
        setOpenNewCategory(false)
        // const _strucRows = []
        let NewRow = []
        const _strucRow = []
        if (rowId) {
            surveyStrucRow.filter(st => st?.id !== rowId).map(sl => {
                return _strucRow.push(sl)
            })
            _strucRow.push(surveyStruc)
            NewRow = _strucRow
            setSurveyStrucRow(_strucRow)
        } else {
            if (surveyStrucRow?.length > 0) {
                surveyStrucRow.map(sl => {
                    return _strucRow.push({ id: uuidv4(), ...sl })
                })
                // console.log("Add Rows")
                _strucRow.push({
                    "id": uuidv4(),
                    "subfactors": [],
                    ...surveyStruc
                })
                NewRow = _strucRow
                setSurveyStrucRow(_strucRow)
            } else {
                // console.log("New Rows")
                NewRow = [
                    {
                        "id": uuidv4(),
                        "subfactors": [],
                        ...surveyStruc
                    }]
                setSurveyStrucRow(NewRow)
            }
        }


        dispatch({
            type: SG_EDIT_SURVEY_STRUCTURE,
            payload: {
                id: surveyStructureId,
                organization: organizationId,
                categories: NewRow,
            },
        });
        setSurveyStruc({})
        setLoading(true)
        setUpdateJsonFile(0)
    }



    useEffect(() => {
        const ErrorList = []
        if (!surveyStruc?.priority) {
            ErrorList.push("Select a Priority")
        }
        if (!surveyStruc?.name) {
            ErrorList.push("Enter a Name")
        }
        if (!surveyStruc?.subtitle) {
            ErrorList.push("Enter a Subtitle")
        }

        if (!surveyStruc?.options || surveyStruc?.options?.length === 0) {
            ErrorList.push("Add atleast one option")
        }
        const accessOrderValue = surveyStruc?.access_order;
        if (
            accessOrderValue !== undefined &&
            accessOrderValue !== null &&
            accessOrderValue !== "" &&
            (Number.isNaN(Number(accessOrderValue)) || accessOrderValue < 0 || accessOrderValue > 100)
        ) {
            ErrorList.push("Access order must be between 0 and 100");
        }
        setFormErrors(ErrorList)
    }, [surveyStruc, updated]);

    function reset() {
        setOpenNewCategory(false)
    }

    function AddAllToList() {
        const _survey = surveyStruc
        const _options = _survey?.options ? _survey?.options : []
        optionList.map(o => 
            _options.push(o)
            )
        
        _survey.options = _options
        setSurveyStruc(_survey)
        setListName('')
        setUpdated(Math.random())
    }

    function AddToList() {
        setSurveyStruc(prevState => ({
            ...prevState,
            options: [
                ...(prevState.options || []),
                selectedOptionList,
            ],
        }));
        setListName('');
        setUpdated(Math.random());
    }
    

    function RemoveFromList(key) {
        let newErrors = formErrors;
    
        setSurveyStruc(prevState => {
            const RemoveName = prevState.options[key]?.name;
            let SubFactors = prevState.subfactors || [];
    
            // Remove subfactors if they match the removed option
            SubFactors = SubFactors.filter(ss => ss.option !== RemoveName);
    
            // Remove the option from the list
            const newOptions = prevState.options.filter((_, index) => index !== key);
    
            // Handle form errors if no options are left
            if (newOptions.length === 0) {
                newErrors = [...formErrors, "Add at least one option"];
            }
    
            // Update the survey structure
            return {
                ...prevState,
                options: newOptions,
                subfactors: SubFactors.length > 0 ? SubFactors : prevState.subfactors,
            };
        });
    
        // Trigger updates
        setFormErrors(newErrors);
        setUpdated(Math.random());
        setUpdateJsonFile(Math.random());
    }
    
    

    function AddDetails(name, value) {
        setSurveyStruc(prevState => ({
            ...prevState,
            [name]: value,
        }));
        setUpdated(Math.random());
        setUpdateJsonFile(Math.random());
    }

    function UpdateAccessOrder(value) {
        setSurveyStruc(prevState => {
            const next = { ...prevState };
            if (value === null) {
                delete next.access_order;
            } else {
                next.access_order = value;
            }
            return next;
        });
        setUpdated(Math.random());
        setUpdateJsonFile(Math.random());
    }

    function HandleAccessOrderChange(event) {
        const rawValue = event.target.value;
        if (rawValue === "") {
            UpdateAccessOrder(null);
            return;
        }
        const parsed = Number(rawValue);
        if (Number.isNaN(parsed)) {
            return;
        }
        const clamped = Math.max(0, Math.min(100, parsed));
        UpdateAccessOrder(clamped);
    }
    



    return (
        <Dialog open={openNewCategory} onOpenChange={setOpenNewCategory}>
            <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-bold text-gray-900">
                        {rowId ? "Update" : "Create"} Category
                    </DialogTitle>
                </DialogHeader>
                
                <div className="space-y-6">
                    {formErrors.length > 0 && !pristine && (
                        <Alert variant="destructive">
                            <AlertCircle className="h-4 w-4" />
                            <AlertDescription>
                                <div className="font-semibold mb-2">We need these details!</div>
                                <ul className="list-disc list-inside space-y-1">
                                    {formErrors.map((error, index) => (
                                        <li key={index}>{error}</li>
                                    ))}
                                </ul>
                            </AlertDescription>
                        </Alert>
                    )}

                    {/* Basic Information */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-lg font-semibold">Basic Information</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <Label htmlFor="priority" className="text-sm font-medium">Priority *</Label>
                                    <Select
                                        placeholder="Select Priority"
                                        onChange={ChangedPriority}
                                        value={prioritySelected}
                                        options={PriorityList}
                                        className="text-sm"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <Label htmlFor="visibility" className="text-sm font-medium">Visibility</Label>
                                    <Select
                                        placeholder="Select Visibility"
                                        onChange={ChangedVisibility}
                                        value={visibilitySelected}
                                        options={CATEGORY_VISIBILITY}
                                        className="text-sm"
                                    />
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <Label htmlFor="name" className="text-sm font-medium">Category Name *</Label>
                                    <ShadcnInput
                                        id="name"
                                        placeholder="Enter category name"
                                        value={surveyStruc?.name || ''}
                                        onChange={(v) => AddDetails("name", v.target.value)}
                                        className="text-sm"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <Label htmlFor="fr_name" className="text-sm font-medium">French Category Name</Label>
                                    <ShadcnInput
                                        id="fr_name"
                                        placeholder="Enter French category name"
                                        value={surveyStruc?.fr_name || ''}
                                        onChange={(v) => AddDetails("fr_name", v.target.value)}
                                        className="text-sm"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="subtitle" className="text-sm font-medium">Subtitle *</Label>
                                <ShadcnInput
                                    id="subtitle"
                                    placeholder="Enter subtitle"
                                    value={surveyStruc?.subtitle || ''}
                                    onChange={(v) => AddDetails("subtitle", v.target.value)}
                                    className="text-sm"
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="input" className="text-sm font-medium">Input Type</Label>
                                <Select
                                    placeholder="Select input type"
                                    onChange={ChangedInput}
                                    value={inputSelected}
                                    options={CATEGORY_INPUT}
                                    className="text-sm"
                                />
                            </div>
                        </CardContent>
                    </Card>

                    {/* Settings */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-lg font-semibold">Settings</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className="flex items-center space-x-2">
                                    <Switch
                                        id="demographic"
                                        checked={demographicValue}
                                        onCheckedChange={ChangedDemograhic}
                                    />
                                    <Label htmlFor="demographic" className="text-sm font-medium">Demographic</Label>
                                </div>
                                
                                <div className="flex items-center space-x-2">
                                    <Switch
                                        id="hidden"
                                        checked={hiddenValue}
                                        onCheckedChange={ChangedHidden}
                                    />
                                    <Label htmlFor="hidden" className="text-sm font-medium">Hidden</Label>
                                </div>
                                
                                <div className="flex items-center space-x-2">
                                    <Switch
                                        id="allow-skip"
                                        checked={allowSkipValue}
                                        onCheckedChange={ChangedAllowSkip}
                                    />
                                    <Label htmlFor="allow-skip" className="text-sm font-medium">Allow Skip</Label>
                                </div>

                                <div className="flex items-center space-x-2">
                                    <Switch
                                        id="require-special-access"
                                        checked={requireSpecialAccessValue}
                                        onCheckedChange={ChangedRequireSpecialAccess}
                                    />
                                    <Label htmlFor="require-special-access" className="text-sm font-medium">
                                        Require Special Access
                                    </Label>
                                </div>

                                <div className="flex items-center space-x-2">
                                    <Switch
                                        id="remove-from-analytics"
                                        checked={removeFromAnalyticsValue}
                                        onCheckedChange={ChangedRemoveFromAnalytics}
                                    />
                                    <Label htmlFor="remove-from-analytics" className="text-sm font-medium">
                                        Remove from Analytics
                                    </Label>
                                </div>

                                <div className="space-y-2">
                                    <Label htmlFor="access-order" className="text-sm font-medium">
                                        Access Order (0-100)
                                    </Label>
                                    <ShadcnInput
                                        id="access-order"
                                        type="number"
                                        inputMode="numeric"
                                        min={0}
                                        max={100}
                                        placeholder="Enter access order"
                                        value={surveyStruc?.access_order ?? ""}
                                        onChange={HandleAccessOrderChange}
                                        className="text-sm"
                                    />
                                    <p className="text-xs text-muted-foreground">
                                        Set relative ordering for access (0 shows first).
                                    </p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                    {/* Questions */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-lg font-semibold">Questions</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-4">
                            <div className="space-y-2">
                                <Label htmlFor="question" className="text-sm font-medium">Question</Label>
                                <ShadcnInput
                                    id="question"
                                    placeholder="Enter question"
                                    value={surveyStruc?.question || ''}
                                    onChange={(v) => AddDetails("question", v.target.value)}
                                    className="text-sm"
                                />
                            </div>
                            
                            <div className="space-y-2">
                                <Label htmlFor="fr_question" className="text-sm font-medium">French Question</Label>
                                <ShadcnInput
                                    id="fr_question"
                                    placeholder="Enter French question"
                                    value={surveyStruc?.fr_question || ''}
                                    onChange={(v) => AddDetails("fr_question", v.target.value)}
                                    className="text-sm"
                                />
                            </div>
                        </CardContent>
                    </Card>

                    {/* Open Ended Options */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-lg font-semibold">Open Ended Options</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-4">
                            <div className="flex items-center space-x-2">
                                <Switch
                                    id="allow-open-ended"
                                    checked={allowOpenEndedValue}
                                    onCheckedChange={ChangedAllowOpenEnded}
                                />
                                <Label htmlFor="allow-open-ended" className="text-sm font-medium">Allow Open Ended Option</Label>
                            </div>
                            
                            {allowOpenEndedValue && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                                    <div className="space-y-2">
                                        <Label htmlFor="open-ended-name" className="text-sm font-medium">Open Ended Option Name</Label>
                                        <ShadcnInput
                                            id="open-ended-name"
                                            placeholder="Enter open ended option name"
                                            value={openEndedName}
                                            onChange={(v) => {
                                                setOpenEndedName(v.target.value);
                                                AddDetails("open_ended_name", v.target.value);
                                            }}
                                            className="text-sm"
                                        />
                                    </div>
                                    
                                    <div className="space-y-2">
                                        <Label htmlFor="open-ended-name-fr" className="text-sm font-medium">French Open Ended Option Name</Label>
                                        <ShadcnInput
                                            id="open-ended-name-fr"
                                            placeholder="Enter French open ended option name"
                                            value={openEndedNameFr}
                                            onChange={(v) => {
                                                setOpenEndedNameFr(v.target.value);
                                                AddDetails("open_ended_name_fr", v.target.value);
                                            }}
                                            className="text-sm"
                                        />
                                    </div>
                                </div>
                            )}
                        </CardContent>
                    </Card>

                    {/* Options Management */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-lg font-semibold">Options Management</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-6">
                            {/* Current Options */}
                            <div className="space-y-3">
                                <Label className="text-sm font-medium">Current Options</Label>
                                {surveyStruc?.options?.length > 0 ? (
                                    <div className="space-y-2">
                                        {surveyStruc.options.map((item, key) => (
                                            <div key={key} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
                                                <div className="flex items-center space-x-3">
                                                    <div 
                                                        className="w-6 h-6 rounded-full border-2 border-gray-300"
                                                        style={{ backgroundColor: item?.color || '#BCBCBC' }}
                                                    />
                                                    <span className="text-sm font-medium">{item?.name}</span>
                                                </div>
                                                <ShadcnButton
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={() => RemoveFromList(key)}
                                                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                                                >
                                                    <Minus className="h-4 w-4" />
                                                </ShadcnButton>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-sm text-gray-500 italic">No options added yet</div>
                                )}
                            </div>

                            <Separator />

                            {/* Add Options from Compliance List */}
                            <div className="space-y-3">
                                <Label className="text-sm font-medium">Add Options from Compliance List</Label>
                                <div className="flex space-x-2">
                                    <div className="flex-1">
                                        <Select
                                            placeholder="Select Options"
                                            onChange={ChangedOption}
                                            getOptionLabel={(option) => option?.name}
                                            getOptionValue={(option) => option?.id}
                                            value={selectedOptions}
                                            options={get_category_compliance}
                                            className="text-sm"
                                        />
                                    </div>
                                    <ShadcnButton 
                                        onClick={AddAllToList}
                                        variant="outline"
                                        className="px-4"
                                    >
                                        Add All
                                    </ShadcnButton>
                                </div>
                            </div>

                            <Separator />

                            {/* Add Individual Options */}
                            <div className="space-y-3">
                                <Label className="text-sm font-medium">Add Individual Options</Label>
                                <div className="flex space-x-2">
                                    <div className="flex-1">
                                        <Select
                                            placeholder="Select Option"
                                            onChange={ChangedOptionList}
                                            getOptionLabel={(option) => option?.name}
                                            getOptionValue={(option) => option?.id}
                                            value={selectedOptionList}
                                            options={optionList}
                                            className="text-sm"
                                        />
                                    </div>
                                    <ShadcnButton 
                                        onClick={AddToList}
                                        variant="outline"
                                        className="px-4"
                                    >
                                        <Plus className="h-4 w-4 mr-1" />
                                        Add
                                    </ShadcnButton>
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Action Buttons */}
                    <div className="flex justify-end space-x-3 pt-4">
                        <ShadcnButton
                            variant="outline"
                            onClick={() => reset()}
                            className="px-6"
                        >
                            Cancel
                        </ShadcnButton>
                        <ShadcnButton
                            onClick={onSubmit}
                            disabled={formErrors.length > 0 && !pristine}
                            className="px-6 bg-blue-600 hover:bg-blue-700"
                        >
                            {rowId ? "Update" : "Create"} Category
                        </ShadcnButton>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default NewCategory
